import { ValidationResult } from '@/utils/validation';

import { CreateOrganizationFormData } from './types';
import { validationRules } from './validation';

/**
 * Field requirement mapping for organization forms
 */
const fieldRequirements: Record<
  keyof CreateOrganizationFormData,
  (data: CreateOrganizationFormData) => boolean
> = {
  name: () => true,
  type: () => true,
  availableServices: () => true,
};

/**
 * Field validation context mapping
 */
const fieldContext: Record<
  keyof CreateOrganizationFormData,
  (data: CreateOrganizationFormData) => unknown[]
> = {
  name: () => [],
  type: () => [],
  availableServices: () => [],
};

/**
 * Validate all fields in the organization form
 */
export const validateOrganizationForm = (
  data: CreateOrganizationFormData,
): ValidationResult<CreateOrganizationFormData> => {
  const errors: Partial<Record<keyof CreateOrganizationFormData, string>> = {};

  Object.keys(data).forEach((field) => {
    const fieldKey = field as keyof CreateOrganizationFormData;
    const rule = validationRules[fieldKey];
    if (!rule) return;

    const isRequired = fieldRequirements[fieldKey](data);
    const hasValue = data[fieldKey] != null;

    if (isRequired || (rule.required === false && hasValue)) {
      const context = fieldContext[fieldKey](data);
      const error = rule.validate(data[fieldKey], ...context);
      if (error) {
        errors[fieldKey] = error;
      }
    }
  });

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

// Export validation rules for potential external use
export { validationRules };
